import React from 'react'

const ButtonLoader = () => {
    return (
        <div className="loader-box ms-3">
            <div className="loader-3"></div>
        </div>
    )
}

export default ButtonLoader